import React from 'react';
import { persistor, store } from '@redux/store';
import { Provider } from 'react-redux';
import RootRouter from 'routes';
import { PersistGate } from 'redux-persist/integration/react';
import { OverwriteAntdGlobalStyle, LayoutStyle, TextStyle } from 'styles';
import GlobalDndContext from 'dnd-context';

function App() {
  return (
    <Provider store={store}>
      <LayoutStyle />
      <TextStyle />
      <OverwriteAntdGlobalStyle />
      <PersistGate loading={null} persistor={persistor}>
        <GlobalDndContext>
          <RootRouter />
        </GlobalDndContext>
      </PersistGate>
    </Provider>
  );
}

export default App;
